<script setup >
import { selectedLang } from '../../utils/selected_lang';

</script>

<template>
    <section class="infra-section">
        <div class="image">
            <img src="/images/medical_bg2.jpg" alt="" data-aos="zoom-out-up">
        </div>
        <div class="infra-layer-container">
            <div class="infra-layer"
                :class="{ 'infra-layer': selectedLang() == 'en', 'infra-layer-k': selectedLang() != 'en' }">
                <div class="title" data-aos="fade-up" data-aos-delay="100">
                    <span v-if="selectedLang() == 'en'">KURDOS INFRA</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl"> بنية کوردوس </bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">ژێرخانی کوردۆس</bdo></span>
                </div>
                <p style="font-size: 18px;color: #E43D34;"  data-aos="fade-up" data-aos-delay="200"><strong>
                        <span v-if="selectedLang() == 'en'">Hospital Infrastructure Solutions</span>
                        <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">حلول البنية التحتية
                                للمستشفيات</bdo></span>
                        <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">چارەسەری ژێرخانی
                                نەخۆشخانەکان</bdo></span>
                    </strong></p>
                <p  class="text" data-aos="fade-up" data-aos-delay="300">

                    <span v-if="selectedLang() == 'en'">Kurdos Infra offers Turnkey Solutions for Healthcare
                        Projects, be it
                        Green Field, Brown Field,
                        upgradation of existing Hospitals, Operation Theatre Complex , Medical Gas Pipeline
                        Systems etc.</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">تقدم شركة كردوس إنفرا حلولاً متكاملة لمشاريع
                            الرعاية الصحية، سواءً كانت مشاريع جاهزة أو قيد الإنشاء، أو تطوير المستشفيات القائمة، أو
                            مجمع غرف العمليات، أو أنظمة أنابيب الغاز الطبي، وغيرها.</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl"></bdo>کوردۆس ئینفرا چارەسەری کلیل بەدەست بۆ
                        پڕۆژەکانی چاودێری تەندروستی پێشکەش دەکات،
                        بێت
                        گرین فیڵد، براون فیڵد، بەرزکردنەوەی نەخۆشخانەکانی ئێستا، کۆمەڵگەی شانۆی نەشتەرگەری , سیستەمی
                        بۆری غازی پزیشکی و هتد.</span>
                </p>
                <button @click="gotoInfra" data-aos="fade-up" data-aos-delay="400">
                    <span v-if="selectedLang() == 'en'" style="text-align: center;">Learn More</span>
                    <span v-if="selectedLang() == 'ar'" style="text-align: center;"><bdo dir="rtl">اقرا
                            مزيد</bdo></span>
                    <span v-if="selectedLang() == 'ku'" style="text-align: center;"><bdo dir="rtl">زیاتر
                            بزانە</bdo></span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#E43D34" viewBox="0 0 256 256"
                        :class="{ 'svgen': selectedLang() == 'en', 'svgk': selectedLang() != 'en' }">
                        <path
                            d="M224.49,136.49l-72,72a12,12,0,0,1-17-17L187,140H40a12,12,0,0,1,0-24H187L135.51,64.48a12,12,0,0,1,17-17l72,72A12,12,0,0,1,224.49,136.49Z">
                        </path>
                    </svg>
                </button>
            </div>
        </div>
    </section>
</template>
<style scoped>
.infra-section {
    padding: 20px;
    position: relative;
}

button {
    border: 1px solid #E43D34 !important;
    color: #E43D34 !important;
    background-color: transparent;
    text-transform: uppercase;
    border-radius: 25px;
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 13px 55px;
    border: none;
    position: relative;
    margin-top: 30px;
    cursor: pointer;
}

button {
    margin-top: 10px;
}

button .svgen {
    position: absolute;
    margin: 5px 14px;
    right: 0;
    transition: 0.2s linear;
}
.title{
    font-size: 30px;color: #0B3A64;line-height: 2rem !important;
}
.dark .title{
    color: white;
}

.text{
    color: #073762;
}
.dark .text{
    color: white;
}
button .svgk {
    left: 0;
    transform: rotate(180deg);
}

button:hover .svgen {
    transform: translateX(5px);
}

button:hover .svgk {
    transform: translateX(-5px) rotate(180deg);
}


.image {
    display: flex;
    justify-content: end;
}

.image img {
    width: 70%;
    border-radius: 20px;
}

.infra-layer-container {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}

.infra-layer-container .infra-layer {
    box-shadow: 0 0 15px rgba(0, 0, 0, .1);
    position: absolute;
    padding: 60px 70px;
    left: 5%;
    width: 35%;
    transform: translateY(-50%);
    border-radius: 15px;
    top: 50%;
    background-color: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(20px);
    display: flex;
    justify-items: center;
    align-items: start;
    flex-direction: column;
}
.dark .infra-layer-container .infra-layer{
    background-color: rgba(0, 0, 0, 0.6);
}

.infra-layer-container .infra-layer h1 {
    color: white;
}

.infra-section {
    position: relative;
}

.infra-layer-k {
    right: 5% !important;
}

@media (max-width:1000px) {
    .infra-layer {
        position: relative !important;
        top: -100px !important;
        width: 80% !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
        padding: 40px !important
    }

    .infra-layer-container{
        position: relative;
    }

    .image img {
        width: 100%;
    }
}
</style>
